import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { Link, withRouter, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from '../../NewProfile/Header';
import ScrollLock from 'react-scrolllock';
import SideBarContent from '../../SideBar/SideBarContent';
// import driverPolicy from './driverPolicy';
import DriverChecklist from './DriverChecklist';
import Damages from './Damages';
import FeeTable from './FeeTable';
import GasShortages from './GasShortages';
import IncorrectUse from './IncorrectUse';
import LateReturn from './LateReturn';
import './driverPolicy.css';

class DriverPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate() {}

  policy = () => {
    const { history, operatingCity } = this.props;
    return (
      <Fragment>
        <Helmet>
          <title>Driver Policy | Autzu</title>
          <meta name="description" content="" />
        </Helmet>
        <div className="driverPolicy">
          {/rls/.test(window.location.href) ? null : (
            <Header
              persistentTitle
              title="Important Rules"
              back
              onClick={() => {
                history.goBack();
              }}
            />
          )}
          <ScrollLock>
            <div
              className="driverPolicy__body container driverPolicy__scroll"
              style={{
                marginTop: /rls/.test(window.location.href) ? '0' : ''
              }}>
              <div className="driverPolicy__container">
                <div className="driverPolicy__sidebar">
                  <SideBarContent
                    status={this.props.status}
                    signedIn={this.props.loggedIn}
                  />
                </div>

                <div className="driverPolicy__content--container">
                  <span id="top" className="anchor"></span>
                  <DriverChecklist ref city={operatingCity} />
                  <FeeTable id="feetable" city={operatingCity} />
                  <Damages city={operatingCity} />
                  <div className="totop">
                    <a href="#top">Back to the top &#8963;</a>
                    <br />
                  </div>
                  <br />
                  <GasShortages city={operatingCity} />
                  <div className="totop">
                    <a href="#top">Back to the top &#8963;</a>
                    <br />
                  </div>
                  <br />
                  <IncorrectUse city={operatingCity} />
                  <div className="totop">
                    <a href="#top">Back to the top &#8963;</a>
                    <br />
                  </div>
                  <LateReturn city={operatingCity} />
                  <div className="totop">
                    <a href="#top">Back to the top &#8963;</a>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </ScrollLock>
        </div>
      </Fragment>
    );
  };

  render() {
    return this.policy();
  }
}
export default withRouter(DriverPolicy);



// WEBPACK FOOTER //
// ./src/components/Static/DriverPolicy/index.js